module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 83.05 5.69"}},[_c('title',[_v("sq-linebreak")]),_c('path',{attrs:{"d":"M25.03 5.69l-8.24-4.14-8.24 4.14L0 1.39.62.16l7.93 3.98L16.79 0l8.24 4.14L33.27 0l8.24 4.14L49.76 0 58 4.14 66.24 0l8.25 4.14L82.43.16l.62 1.23-8.56 4.3-8.25-4.14L58 5.69l-8.24-4.14-8.25 4.14-8.24-4.14-8.24 4.14z","data-name":"Layer 2"}})])}}};


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sq-linebreak.svg
// module id = 116
// module chunks = 1